import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pa-3"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 4 }
const _hoisted_4 = ["data-cy"]
const _hoisted_5 = { class: "pa-2 d-flex align-center justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-center justify-center fill-height"
}
const _hoisted_7 = {
  class: "text-center",
  style: {"width":"750px"}
}
const _hoisted_8 = { style: {"width":"1100px"} }
const _hoisted_9 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_10 = { style: {"width":"1100px"} }
const _hoisted_11 = {
  key: 0,
  class: "ml-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_TaxFormEDIReport = _resolveComponent("TaxFormEDIReport")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_BundleDetails = _resolveComponent("BundleDetails")!
  const _component_BookletGenerator = _resolveComponent("BookletGenerator")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_TaxForm = _resolveComponent("TaxForm")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_ctx.companyId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "mb-2 rounded-xl bg-white"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_back, {
                  class: "ml-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
                }),
                _createVNode(_component_v_select_filled, {
                  modelValue: _ctx.selectedView,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedView) = $event)),
                  items: _ctx.viewsToDisplay,
                  outlined: "",
                  class: "mx-2",
                  "hide-details": "",
                  style: {"width":"80px"},
                  "data-cy": "TaxFormManager-selectedView",
                  density: "compact",
                  "item-title": "text",
                  "item-value": "value"
                }, null, 8, ["modelValue", "items"]),
                (_ctx.selectedView === 'booklet')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_ctx.bookletTemplates && _ctx.bookletTemplates.length)
                        ? (_openBlock(), _createBlock(_component_v_select_filled, {
                            key: 0,
                            modelValue: _ctx.selectedTemplateTemp,
                            "onUpdate:modelValue": [
                              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTemplateTemp) = $event)),
                              _ctx.onBookletTemplateChange
                            ],
                            items: _ctx.bookletTemplates,
                            class: "mr-2",
                            "item-value": "id",
                            "item-title": "name",
                            "hide-details": "",
                            "return-object": "",
                            density: "compact"
                          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                (_ctx.selectedTaxFormIndex !== 0 && _ctx.selectedView !== 'booklet')
                  ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
                      key: 1,
                      modelValue: _ctx.formDisplayMode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formDisplayMode) = $event)),
                      class: "ml-6",
                      mandatory: "force",
                      density: "compact",
                      group: "",
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          value: "TaxFormTable",
                          "data-cy": "TaxFormManager-saisie"
                        }, {
                          default: _withCtx(() => _cache[77] || (_cache[77] = [
                            _createTextVNode(" Saisie ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          value: "TaxFormPng",
                          "data-cy": "TaxFormManager-cerfa"
                        }, {
                          default: _withCtx(() => _cache[78] || (_cache[78] = [
                            _createTextVNode(" Cerfa ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.companyBundleType !== 'BNC')
                  ? (_openBlock(), _createBlock(_component_v_spacer, { key: 2 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                (_ctx.selectedView === 'bundle')
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 3,
                      location: "bottom"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn_icon, _mergeProps({
                          class: "mr-2 mt-1",
                          rounded: "circle",
                          elevation: "0"
                        }, props, {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openGeneralLedger())),
                          icon: "$oss-general-ledger",
                          color: "primary"
                        }), null, 16)
                      ]),
                      default: _withCtx(() => [
                        _cache[79] || (_cache[79] = _createElementVNode("span", null, "Balance / Grand-Livre", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.bundleDependenciesErrors && !_ctx.isSent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_warning, _mergeProps({ class: "mr-2 mt-1" }, props, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleDependenciesErrorsDialog()))
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[80] || (_cache[80] = _createElementVNode("span", null, "Champs manquants", -1))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedView === 'bundle' && !_ctx.isSent)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 5,
                      location: "bottom"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: "mr-2 mt-1",
                          size: "small",
                          fab: "",
                          elevation: "0"
                        }, props, {
                          color: "#FFF",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleChecksDialog()))
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_badge, {
                              color: "red",
                              content: _ctx.errorsCount
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  class: "pb-1",
                                  color: "primary",
                                  size: "x-large"
                                }, {
                                  default: _withCtx(() => _cache[81] || (_cache[81] = [
                                    _createTextVNode("$oss-warning")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["content"])
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _cache[82] || (_cache[82] = _createElementVNode("span", null, "Contrôles de cohérence", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  disabled: _ctx.isSaveDisabled,
                  rounded: "",
                  elevation: "0",
                  class: "mr-2",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveBundle())),
                  "data-cy": "TaxFormManager-save",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[83] || (_cache[83] = [
                    _createTextVNode(" Enregistrer ")
                  ])),
                  _: 1
                }, 8, ["disabled"]),
                (_ctx.company && _ctx.company.taxSystemType === 'IS')
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 6,
                      disabled: !_ctx.bundleId,
                      location: "bottom"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                          _createVNode(_component_v_btn, {
                            disabled: !_ctx.bundleId,
                            rounded: "",
                            elevation: "0",
                            class: "mr-2",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (
                                    _ctx.$router.push({
                                        name: 'corporate-tax',
                                        params: {
                                            companyId: _ctx.companyId,
                                            accountingPeriodId: _ctx.accountingPeriodId,
                                            acKey: 'yZCapzwZiGhZ81RFS40tDW8i',
                                        },
                                    })
                                )),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[84] || (_cache[84] = [
                              _createTextVNode(" Calcul IS ")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ], 16)
                      ]),
                      default: _withCtx(() => [
                        _cache[85] || (_cache[85] = _createElementVNode("span", null, "Lien vers le dossier de révision - \"Contrôle de calcul et comptabilisation de l'Impôt sur les Sociétés\"", -1))
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isTrainingOffer)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 7 }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          disabled: true,
                          rounded: "",
                          elevation: "0",
                          class: "mr-2",
                          size: "small"
                        }, props), {
                          default: _withCtx(() => _cache[86] || (_cache[86] = [
                            _createTextVNode(" Télédéclaration ")
                          ])),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.normal-text")), 1)
                      ]),
                      _: 1
                    }))
                  : (
                        _ctx.isSendBundleDisabled &&
                        _ctx.bundle &&
                        _ctx.bundle.unaffectedAccounts &&
                        _ctx.bundle.unaffectedAccounts.length
                    )
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 8,
                        text: "                     \n                        Un ou plusieurs comptes de la balance ne sont pas affectés dans la liasse\n                    ",
                        location: "bottom"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("span", _mergeProps(props, { style: {"display":"inline-block"} }), [
                            _createVNode(_component_v_btn, {
                              disabled: true,
                              rounded: "",
                              elevation: "0",
                              class: "mr-2",
                              size: "small",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openBundleDeclarationDialog()))
                            }, {
                              default: _withCtx(() => _cache[87] || (_cache[87] = [
                                _createTextVNode(" Télédéclaration ")
                              ])),
                              _: 1
                            })
                          ], 16)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 9,
                        disabled: _ctx.isSendBundleDisabled,
                        rounded: "",
                        elevation: "0",
                        class: "mr-2",
                        size: "small",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openBundleDeclarationDialog()))
                      }, {
                        default: _withCtx(() => _cache[88] || (_cache[88] = [
                          _createTextVNode(" Télédéclaration ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])),
                _createVNode(_component_v_menu, {
                  "offset-y": "",
                  "close-on-content-click": false
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, { class: "d-flex align-center" }), null, 16)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.instructionsDialog = true))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[90] || (_cache[90] = [
                                _createTextVNode("$oss-help")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[89] || (_cache[89] = [
                                _createTextVNode("Notice d'utilisation")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, {
                          disabled: _ctx.isSent,
                          class: "pr-2"
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.enableEdition,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.enableEdition) = $event)),
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[91] || (_cache[91] = [
                                _createTextVNode("Autoriser la modification")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_list_item, {
                          disabled: _ctx.isSent,
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.refreshGeneralLedger()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              disabled: _ctx.isSent,
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[93] || (_cache[93] = [
                                _createTextVNode("$fa-redo-alt")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[92] || (_cache[92] = [
                                _createTextVNode("Recalculer la balance")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_list_item, {
                          disabled: _ctx.isSent,
                          onClick: _cache[14] || (_cache[14] = ($event: any) => {
                                _ctx.createRows();
                                _ctx.miscellaneousOperationDialog = true;
                            })
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              disabled: _ctx.isSent,
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[95] || (_cache[95] = [
                                _createTextVNode("$oss-edit")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[94] || (_cache[94] = [
                                _createTextVNode("Passage d'OD")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openPrintFormsDialog(false))),
                          disabled: !_ctx.referencedForms || !_ctx.referencedForms.length
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[97] || (_cache[97] = [
                                _createTextVNode("$oss-download")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[96] || (_cache[96] = [
                                _createTextVNode("Impression")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.generateBookletDialog = true)),
                          disabled: !_ctx.bundleId
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[99] || (_cache[99] = [
                                _createTextVNode("$oss-file")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[98] || (_cache[98] = [
                                _createTextVNode("Plaquette")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateDeclarationStatus()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[101] || (_cache[101] = [
                                _createTextVNode("$fa-redo-alt")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[100] || (_cache[100] = [
                                _createTextVNode("Mettre à jour le statut")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.duplicateBundle()))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => _cache[103] || (_cache[103] = [
                                _createTextVNode("$oss-duplicate")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[102] || (_cache[102] = [
                                _createTextVNode("Dupliquer la liasse")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.duplicateBundleLoading)
                          ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  size: "28",
                                  color: "primary",
                                  class: "mx-auto"
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_TaxFormEDIReport, { taxFormId: _ctx.bundleId }, {
                          default: _withCtx(({ statusOk, mtaeProof }) => [
                            _createVNode(_component_v_list_item, {
                              disabled: !_ctx.isSent || !statusOk,
                              onClick: mtaeProof
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[105] || (_cache[105] = [
                                    _createTextVNode("$oss-download")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[104] || (_cache[104] = [
                                    _createTextVNode("Impression justificatf EDI")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["taxFormId"]),
                        (_ctx.isSent && _ctx.isUserAuthorized && _ctx.xml)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.downloadXMLFile()))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[107] || (_cache[107] = [
                                    _createTextVNode("$oss-download")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[106] || (_cache[106] = [
                                    _createTextVNode("Télécharger le fichier XML")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          "no-gutters": "",
          style: {"flex-wrap":"nowrap"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "2",
              class: "fill-height border-none flex-grow-0 flex-shrink-1 mr-2"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  style: {"height":"calc(100vh - 232px)","overflow-y":"auto"},
                  key: _ctx.referencedFormRefreshKey
                }, [
                  _createVNode(_component_v_tabs, {
                    direction: "vertical",
                    modelValue: _ctx.selectedTaxFormIndex,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedTaxFormIndex) = $event)),
                    class: "rounded-xl",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, {
                        class: "d-flex justify-start",
                        value: "-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.firstTabTitle), 1)
                        ]),
                        _: 1
                      }),
                      (!_ctx.loaded)
                        ? (_openBlock(), _createBlock(_component_v_tab, {
                            key: 0,
                            class: "d-flex justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_progress_circular, {
                                color: "primary",
                                indeterminate: "",
                                size: "28",
                                class: "mx-auto"
                              })
                            ]),
                            _: 1
                          }))
                        : (_ctx.referencedForms)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.referencedForms, (sheet, index) => {
                              return (_openBlock(), _createBlock(_component_v_tab, {
                                value: index + 1,
                                class: "d-flex justify-space-between",
                                "model-value": sheet.cerfaNumber
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_tooltip, {
                                    location: "end",
                                    activator: "parent"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("p", _mergeProps({ ref_for: true }, props, {
                                        class: "mb-0",
                                        "data-cy": 'TaxFormManager-name-' + index
                                      }), _toDisplayString(_ctx.selectedView === "bundle"
                                                    ? _ctx.displayCerfaName(sheet)
                                                    : _ctx.cleanSheetTitle(sheet)), 17, _hoisted_4),
                                      _createVNode(_component_v_spacer)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedView === "bundle"
                                            ? sheet.title
                                            : _ctx.displayCerfaName(sheet)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (
                                        _ctx.selectedView === 'bundle' &&
                                        !_ctx.isMandatoryForm(sheet.cerfaNumber) &&
                                        !_ctx.isSent
                                    )
                                    ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (_ctx.openDialogToDeleteBundleSheetFromForm(sheet)), ["stop"]),
                                        size: "small"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["value", "model-value"]))
                            }), 256))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.selectedView === 'bundle')
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        disabled: _ctx.isSent,
                        rounded: "",
                        elevation: "0",
                        block: "",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.openAddFormDialog())),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[108] || (_cache[108] = [
                          _createElementVNode("span", { class: "subtitle-1 white--text" }, "+", -1)
                        ])),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_oss_dialog, {
                  modelValue: _ctx.addFormDialog,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.addFormDialog) = $event)),
                  title: "Ajouter un formulaire à la liasse"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "py-1",
                      style: {"width":"750px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.searchForm,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.searchForm) = $event)),
                              label: "Rechercher",
                              outlined: "",
                              "hide-details": "",
                              density: "compact",
                              "append-inner-icon": "$search",
                              clearable: "",
                              "onClick:clear": _cache[23] || (_cache[23] = ($event: any) => (_ctx.searchForm = ''))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          style: {"max-height":"calc(100vh - 200px)","overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, { "two-lines": "" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptionalForms, (form, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: index,
                                    onClick: ($event: any) => (_ctx.formToAdd(form)),
                                    "two-lines": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(form.cerfa), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"break-spaces"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(form.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128)),
                                (!_ctx.filteredOptionalForms.length)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      "two-lines": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[109] || (_cache[109] = [
                                            _createTextVNode("Aucun formulaire trouvé pour ce résultat")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "10",
              class: "px-2 flex-grow-1 flex-shrink-0 document-card",
              style: {"max-height":"calc(100vh - 150px)","overflow":"auto"}
            }, {
              default: _withCtx(() => [
                (!_ctx.accountingPeriodId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Pour pouvoir accéder au formulaire, veuillez sélectionner une periode comptable. "))
                  : (_openBlock(), _createBlock(_component_v_window, {
                      key: 1,
                      modelValue: _ctx.selectedTaxFormIndex,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selectedTaxFormIndex) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_v_window_item, {
                          key: 0,
                          value: 0
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_BundleDetails, {
                              onVariablesUpdated: _cache[25] || (_cache[25] = ($event: any) => (_ctx.fixedVariablesUpdated($event))),
                              onVariablesFetched: _cache[26] || (_cache[26] = ($event: any) => (_ctx.fixedVariablesFetched($event))),
                              onShareQuantityDifferenceIsOverZero: _cache[27] || (_cache[27] = ($event: any) => (
                                _ctx.shareQuantityDifferenceIsOverZero = true
                            )),
                              bundleId: _ctx.bundleId,
                              isSent: _ctx.isSent
                            }, null, 8, ["bundleId", "isSent"]), [
                              [_vShow, _ctx.selectedView === 'bundle']
                            ]),
                            (_ctx.bundle && _ctx.bundle.bookletTemplate)
                              ? _withDirectives((_openBlock(), _createBlock(_component_BookletGenerator, {
                                  key: 0,
                                  modelValue: _ctx.bundle.bookletTemplate,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.bundle.bookletTemplate) = $event)),
                                  onChangeBookletGenerator: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onBookletChange($event))),
                                  bundleType: _ctx.bundleType,
                                  importFilesMillesimfromBundle: 
                                _ctx.bundle ? _ctx.bundle.importFilesMillesim : null
                            
                                }, null, 8, ["modelValue", "bundleType", "importFilesMillesimfromBundle"])), [
                                  [_vShow, _ctx.selectedView === 'booklet']
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referencedForms, (sheet, index) => {
                          return (_openBlock(), _createBlock(_component_v_window_item, {
                            key: index + 1,
                            value: index + 1
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_TaxForm, {
                                  ref_for: true,
                                  ref: "taxForm",
                                  cerfaNumber: sheet.cerfaNumber,
                                  activeTab: _ctx.formDisplayMode,
                                  sheet: sheet,
                                  loaded: _ctx.loaded,
                                  enableEdition: _ctx.enableEdition,
                                  isSent: _ctx.isSent && _ctx.selectedView === 'bundle',
                                  onFieldUpdate: _ctx.onTaxFormChanged,
                                  onAdditionnalPageCreated: _ctx.additionnalPageCreated
                                }, null, 8, ["cerfaNumber", "activeTab", "sheet", "loaded", "enableEdition", "isSent", "onFieldUpdate", "onAdditionnalPageCreated"])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.toDeleteDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 0,
              modelValue: _ctx.toDeleteDialog,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.toDeleteDialog) = $event)),
              title: "Suppression d'un formulaire",
              onValid: _cache[32] || (_cache[32] = ($event: any) => (_ctx.deleteBundleSheet()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, " Êtes-vous sûr(e) de vouloir supprimer le formulaire " + _toDisplayString(_ctx.displayCerfaName(_ctx.toDeleteSheet)) + " ? ", 1)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.dependenciesErrorsDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 1,
              modelValue: _ctx.dependenciesErrorsDialog,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dependenciesErrorsDialog) = $event)),
              title: "Champs manquants",
              "valid-title": "Fermer",
              onValid: _cache[34] || (_cache[34] = ($event: any) => (_ctx.dependenciesErrorsDialog = false)),
              onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.dependenciesErrorsDialog = false))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bundleDependenciesErrors, (form, index1) => {
                  return (_openBlock(), _createBlock(_component_v_row, {
                    "no-gutters": "",
                    key: index1,
                    style: {"width":"750px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "text-left"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(form.cerfa) + " : ", 1)
                        ]),
                        _: 2
                      }, 1024),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.errors, (error, index2) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          cols: "12",
                          key: index1 + '_' + index2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "2" }),
                                _createVNode(_component_v_col, { cols: "10" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Champ concerné : " + _toDisplayString(error.function) + " - Champ manquant : " + _toDisplayString(error.field), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.generalLedgerDialog,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.generalLedgerDialog) = $event)),
          title: "Balance de l'exercice",
          "valid-title": "Fermer",
          onValid: _cache[37] || (_cache[37] = ($event: any) => (_ctx.generalLedgerDialog = false)),
          onClose: _cache[38] || (_cache[38] = ($event: any) => (_ctx.generalLedgerDialog = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_GeneralLedger, {
                ref: "balances",
                companyId: _ctx.companyId,
                accountingPeriodId: _ctx.accountingPeriodId,
                hideOptions: true,
                inNm1: true,
                tableHeight: '63vh',
                bundleGeneralLedger: _ctx.bundle && _ctx.bundle.balances ? _ctx.bundle.balances : null
              }, null, 8, ["companyId", "accountingPeriodId", "bundleGeneralLedger"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.checksDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 2,
              modelValue: _ctx.checksDialog,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.checksDialog) = $event)),
              title: "Contrôle de cohérence",
              error: _ctx.wantToDeclare,
              "valid-title": _ctx.checksDialogValidTitle,
              "previous-display": _ctx.checksWindow === 'balanceErrors',
              onPrevious: _cache[44] || (_cache[44] = ($event: any) => (_ctx.checksWindow = 'allChecks')),
              onValid: _cache[45] || (_cache[45] = ($event: any) => (_ctx.checksDialogValidFunction())),
              onClose: _cache[46] || (_cache[46] = ($event: any) => {
                _ctx.checksDialog = false;
                _ctx.checksWindow = 'allChecks';
            })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window, {
                  modelValue: _ctx.checksWindow,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.checksWindow) = $event)),
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "allChecks" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "mb-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex justify-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  modelValue: _ctx.bundle.showAllConsistencyChecks,
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.bundle.showAllConsistencyChecks) = $event)),
                                  label: "Afficher tous les contrôles",
                                  class: "ml-5",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                (
                                    _ctx.bundle.allChecksValid &&
                                    !_ctx.bundle.showAllConsistencyChecks &&
                                    !_ctx.isBalanceError &&
                                    !_ctx.isFixedAssetsError &&
                                    !_ctx.invalidFixedVariablesCount &&
                                    _ctx.accountsBalanceAnomaliesCount === 0
                                )
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_9, [
                                      _createVNode(_component_v_icon, { class: "mr-2" }, {
                                        default: _withCtx(() => _cache[110] || (_cache[110] = [
                                          _createTextVNode("$oss-circle-check")
                                        ])),
                                        _: 1
                                      }),
                                      _cache[111] || (_cache[111] = _createTextVNode(" Tous les contrôles ont été validés "))
                                    ]))
                                  : (_openBlock(), _createBlock(_component_v_list, {
                                      key: 1,
                                      class: "mb-5"
                                    }, {
                                      default: _withCtx(() => [
                                        (
                                            _ctx.invalidFixedVariablesCount ||
                                            _ctx.bundle.showAllConsistencyChecks
                                        )
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              class: "mt-5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: 
                                                        _ctx.invalidFixedVariablesCount
                                                            ? 'red'
                                                            : 'primary'
                                                    
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.invalidFixedVariablesCount
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => _cache[112] || (_cache[112] = [
                                                            _createTextVNode(" Variables fixes ")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_list_item_subtitle, {
                                                          class: "mt-1",
                                                          style: {"white-space":"normal"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.invalidFixedVariablesCount
                                                            ? "Toutes les variables fixes n'ont pas été renseignées"
                                                            : "Toutes les variables fixes ont été renseignées"), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_btn, {
                                                          rounded: "circle",
                                                          elevation: "0",
                                                          onClick: _cache[40] || (_cache[40] = ($event: any) => {
                                                        _ctx.selectedTaxFormIndex = 0;
                                                        _ctx.checksDialog = false;
                                                    }),
                                                          size: "small",
                                                          icon: "$oss-eye"
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.isBalanceError || _ctx.bundle.showAllConsistencyChecks)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              class: "mt-5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: _ctx.isBalanceError ? 'red' : 'primary'
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.isBalanceError
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => _cache[113] || (_cache[113] = [
                                                            _createTextVNode(" Contrôle de la balance ")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        (_ctx.isBalanceError)
                                                          ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                              key: 0,
                                                              class: "mt-1",
                                                              style: {"white-space":"normal"}
                                                            }, {
                                                              default: _withCtx(() => _cache[114] || (_cache[114] = [
                                                                _createTextVNode(" La balance comptable et la balance de la liasse sont différentes ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                              key: 1,
                                                              class: "mt-1",
                                                              style: {"white-space":"normal"}
                                                            }, {
                                                              default: _withCtx(() => _cache[115] || (_cache[115] = [
                                                                _createTextVNode(" La balance comptable et la balance de la liasse sont identiques ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_ctx.isBalanceError)
                                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 0,
                                                              rounded: "circle",
                                                              elevation: "0",
                                                              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.checksWindow = 'balanceErrors')),
                                                              size: "small",
                                                              icon: "$oss-eye"
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                            _ctx.bundle.unaffectedAccounts.length ||
                                            _ctx.bundle.showAllConsistencyChecks
                                        )
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 2,
                                              class: "mt-5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: 
                                                        _ctx.bundle.unaffectedAccounts.length
                                                            ? 'red'
                                                            : 'primary'
                                                    
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.bundle.unaffectedAccounts.length
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => _cache[116] || (_cache[116] = [
                                                            _createTextVNode(" Affectation des comptes de la balance ")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        (_ctx.bundle.unaffectedAccounts.length)
                                                          ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                              key: 0,
                                                              class: "mt-1",
                                                              style: {"white-space":"normal"}
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(`${
                                                            _ctx.bundle.unaffectedAccounts.length > 1
                                                                ? "Plusieurs comptes de la balance n'ont pas été affectés"
                                                                : "Un compte de la balance n'a pas été affecté"
                                                        } dans la liasse`), 1)
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                              key: 1,
                                                              class: "mt-1",
                                                              style: {"white-space":"normal"}
                                                            }, {
                                                              default: _withCtx(() => _cache[117] || (_cache[117] = [
                                                                _createTextVNode(" Tous les comptes ont été affectés ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "1" })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.isFixedAssetsError || _ctx.bundle.showAllConsistencyChecks)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 3,
                                              class: "mt-5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: _ctx.isFixedAssetsError ? 'red' : 'primary'
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.isFixedAssetsError
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => _cache[118] || (_cache[118] = [
                                                            _createTextVNode(" Contrôle des immobilisations ")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        (_ctx.isFixedAssetsError)
                                                          ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                              key: 0,
                                                              class: "mt-1 long-subtitle"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.bundle.fixedAssetsErrorMessage), 1)
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                              key: 1,
                                                              class: "mt-1",
                                                              style: {"white-space":"normal"}
                                                            }, {
                                                              default: _withCtx(() => _cache[119] || (_cache[119] = [
                                                                _createTextVNode("Pas d'erreur au niveau des immobilisations ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "1" })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                            _ctx.accountsBalanceAnomaliesCount === 0 &&
                                            _ctx.bundle.showAllConsistencyChecks
                                        )
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 4,
                                              class: "mt-5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { color: "primary" }, {
                                                          default: _withCtx(() => _cache[120] || (_cache[120] = [
                                                            _createTextVNode("$oss-circle-check")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => _cache[121] || (_cache[121] = [
                                                            _createTextVNode(" Soldes de la balance ")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_list_item_subtitle, {
                                                          class: "mt-1",
                                                          style: {"white-space":"normal"}
                                                        }, {
                                                          default: _withCtx(() => _cache[122] || (_cache[122] = [
                                                            _createTextVNode(" Aucune anomalie sur les soldes de la balance ")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_ctx.accountsBalanceAnomalies, (account) => {
                                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                                class: "mt-5",
                                                key: account.name
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "1",
                                                        class: "d-flex justify-center align-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { color: "red" }, {
                                                            default: _withCtx(() => _cache[123] || (_cache[123] = [
                                                              _createTextVNode("$oss-warning")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, { cols: "10" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Compte " + _toDisplayString(account.name), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_list_item_subtitle, { class: "mt-1 long-subtitle" }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(account.anomaly), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128)),
                                        (_ctx.missingTaxNumberSCIAssociates)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 6,
                                              class: "mt-5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { color: "red" }, {
                                                          default: _withCtx(() => _cache[124] || (_cache[124] = [
                                                            _createTextVNode("$oss-warning")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => _cache[125] || (_cache[125] = [
                                                            _createTextVNode(" Contrôle des numéros fiscaux ")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_list_item_subtitle, {
                                                          class: "mt-1",
                                                          style: {"white-space":"normal"}
                                                        }, {
                                                          default: _withCtx(() => _cache[126] || (_cache[126] = [
                                                            _createTextVNode(" Le numéro fiscal n'est pas rempli pour tous les associés personne physique ")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "1" })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.shareCapitalIsNotFullyAllocated)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 7,
                                              class: "mt-5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { color: "red" }, {
                                                          default: _withCtx(() => _cache[127] || (_cache[127] = [
                                                            _createTextVNode("$oss-warning")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "10" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => _cache[128] || (_cache[128] = [
                                                            _createTextVNode(" Répartition du capital ")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_list_item_subtitle, {
                                                          class: "mt-1",
                                                          style: {"white-space":"normal"}
                                                        }, {
                                                          default: _withCtx(() => _cache[129] || (_cache[129] = [
                                                            _createTextVNode(" Le capital social n'est pas réparti à 100% ")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "1" })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredConsistencyChecks, (item, key, index) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: index,
                                            class: "mt-5"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "1",
                                                    class: "d-flex justify-center align-center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        color: item.iconColor
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.icon), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { cols: "10" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.label), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_list_item_subtitle, { class: "mt-1 long-subtitle" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.textError), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, {
                                                    cols: "1",
                                                    class: "d-flex justify-center align-center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn, {
                                                        rounded: "circle",
                                                        elevation: "0",
                                                        onClick: ($event: any) => (_ctx.showCellToCheck(item.cerfa)),
                                                        size: "small",
                                                        icon: "$oss-eye"
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  (
                                                    item.subConsistencyChecks &&
                                                    !item.subConsistencyChecks.allChecksValid
                                                )
                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 0,
                                                        cols: "12"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, { cols: "1" }),
                                                              _createVNode(_component_v_col, { cols: "11" }, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item
                                                                .subConsistencyChecks
                                                                .filteredChecks, (subItem, key, index) => {
                                                                    return (_openBlock(), _createBlock(_component_v_row, {
                                                                      "no-gutters": "",
                                                                      key: index
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_col, {
                                                                          cols: "1",
                                                                          class: "d-flex justify-center align-center"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_icon, {
                                                                              color: subItem.iconColor
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(subItem.icon), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["color"])
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024),
                                                                        _createVNode(_component_v_col, { cols: "10" }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(subItem.label), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024),
                                                                            _createVNode(_component_v_list_item_subtitle, { class: "mt-1 long-subtitle" }, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(subItem.textError), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024),
                                                                        _createVNode(_component_v_col, {
                                                                          cols: "1",
                                                                          class: "d-flex justify-center align-center"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_btn, {
                                                                              rounded: "circle",
                                                                              elevation: "0",
                                                                              onClick: ($event: any) => (
                                                                        _ctx.showCellToCheck(
                                                                            subItem.cerfa,
                                                                        )
                                                                    ),
                                                                              size: "small",
                                                                              icon: "$oss-eye"
                                                                            }, null, 8, ["onClick"])
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024))
                                                                  }), 128))
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "balanceErrors" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "d-flex justify-center my-5"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, [
                                      _createVNode(_component_v_icon, {
                                        class: "mr-2",
                                        color: "red"
                                      }, {
                                        default: _withCtx(() => _cache[130] || (_cache[130] = [
                                          _createTextVNode("$oss-warning")
                                        ])),
                                        _: 1
                                      }),
                                      _cache[131] || (_cache[131] = _createTextVNode(" La balance comptable est différente de la balance de la liasse "))
                                    ])
                                  ]),
                                  _: 1
                                }),
                                (_ctx.balanceErrors.aasWithdifferentBalance.length)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      "no-gutters": "",
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "mb-2 pl-5"
                                        }, {
                                          default: _withCtx(() => _cache[132] || (_cache[132] = [
                                            _createElementVNode("h4", null, "Comptes dont le solde a changé :", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "1" }),
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          class: "d-flex justify-start mb-2"
                                        }, {
                                          default: _withCtx(() => _cache[133] || (_cache[133] = [
                                            _createElementVNode("b", null, "Compte", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex justify-end mb-2"
                                        }, {
                                          default: _withCtx(() => _cache[134] || (_cache[134] = [
                                            _createElementVNode("b", null, "Solde compta", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex justify-end mb-2"
                                        }, {
                                          default: _withCtx(() => _cache[135] || (_cache[135] = [
                                            _createElementVNode("b", null, "Solde liasse", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "1" }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.balanceErrors.aasWithdifferentBalance, (aa) => {
                                              return (_openBlock(), _createBlock(_component_v_row, {
                                                "no-gutters": "",
                                                key: aa.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { cols: "1" }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "d-flex justify-start mb-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(aa.aaName), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, {
                                                    cols: "3",
                                                    class: "d-flex justify-end mb-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    Math.abs(aa.aaAccountingBalance),
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, {
                                                    cols: "3",
                                                    class: "d-flex justify-end mb-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    Math.abs(aa.bundleGlBalance),
                                                    undefined,
                                                )), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { cols: "1" })
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.balanceErrors.missingAasInAccountingBalance.length)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 1,
                                      "no-gutters": "",
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "mb-2 pl-5"
                                        }, {
                                          default: _withCtx(() => _cache[136] || (_cache[136] = [
                                            _createElementVNode("h4", null, " Comptes présents dans la liasse mais pas dans la comptabilité : ", -1)
                                          ])),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.balanceErrors.missingAasInAccountingBalance, (aa, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: aa + index
                                          }, [
                                            _createVNode(_component_v_col, { cols: "1" }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-start mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(aa), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ], 64))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.balanceErrors.missingAasInBundleBalance.length)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 2,
                                      "no-gutters": "",
                                      class: "mt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "mb-2 pl-5"
                                        }, {
                                          default: _withCtx(() => _cache[137] || (_cache[137] = [
                                            _createElementVNode("h4", null, " Comptes présents dans la comptabilité mais pas dans la liasse : ", -1)
                                          ])),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.balanceErrors.missingAasInBundleBalance, (aa, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: aa + index
                                          }, [
                                            _createVNode(_component_v_col, { cols: "1" }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-start mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(aa), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ], 64))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue", "error", "valid-title", "previous-display"]))
          : _createCommentVNode("", true),
        (_ctx.confirmCloseWithoutSaveDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 3,
              modelValue: _ctx.confirmCloseWithoutSaveDialog,
              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.confirmCloseWithoutSaveDialog) = $event)),
              title: "Attention",
              "valid-display": false,
              onClose: _cache[50] || (_cache[50] = ($event: any) => {
                _ctx.confirmCloseWithoutSaveDialog = false;
                _ctx.resetRouterNext();
            }),
              "data-cy": "TaxFormManager-valid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => _cache[138] || (_cache[138] = [
                        _createElementVNode("b", null, "Êtes-vous sûr(e) de vouloir quitter sans enregistrer ?", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center align-center mt-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          elevation: "0",
                          class: "mr-2 mt-1",
                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.saveAndExit())),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[139] || (_cache[139] = [
                            _createTextVNode(" Enregistrer et quitter ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          elevation: "0",
                          class: "ml-2 mt-1",
                          outlined: "",
                          onClick: _cache[48] || (_cache[48] = ($event: any) => {
                            _ctx.confirmCloseWithoutSaveDialog = false;
                            _ctx.needSave = false;
                            _ctx.exit();
                        }),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[140] || (_cache[140] = [
                            _createTextVNode(" Quitter sans enregistrer ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.miscellaneousOperationDialog,
          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
          actions: _ctx.actionsMiscellaneousOperation
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.miscellaneousOperationDialog)
                ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                    key: 0,
                    prefilledRows: _ctx.miscellanousOperationData,
                    companyId: _ctx.companyId,
                    onUpsert: _cache[51] || (_cache[51] = ($event: any) => (_ctx.refreshGeneralLedger())),
                    actions: _ctx.actionsMiscellaneousOperation
                  }, null, 8, ["prefilledRows", "companyId", "actions"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "actions"]),
        (_ctx.printFormsDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 4,
              modelValue: _ctx.printFormsDialog,
              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.printFormsDialog) = $event)),
              title: "Impression des formulaires",
              "valid-title": "Imprimer",
              validDisabled: !_ctx.formsSelected.length,
              onValid: _cache[59] || (_cache[59] = ($event: any) => (_ctx.printForms())),
              onClose: _cache[60] || (_cache[60] = ($event: any) => (_ctx.printFormsDialog = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"width":"375px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                          modelValue: _ctx.printFormsMode,
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.printFormsMode) = $event)),
                          inline: "",
                          "hide-details": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: "Saisie",
                              value: "html",
                              color: "primary"
                            }),
                            (_ctx.selectedView === 'bundle')
                              ? (_openBlock(), _createBlock(_component_v_radio, {
                                  key: 0,
                                  label: "Cerfa",
                                  value: "png",
                                  color: "primary"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          modelValue: _ctx.exportWithProjectWatermark,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.exportWithProjectWatermark) = $event)),
                          ripple: false,
                          class: "",
                          title: _ctx.$t('shared.exportWithProjectWatermark'),
                          label: _ctx.$t('shared.exportWithProjectWatermark')
                        }, null, 8, ["modelValue", "title", "label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          elevation: "0",
                          class: "mr-2 mt-1",
                          onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.selectAll())),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[141] || (_cache[141] = [
                            _createTextVNode(" Tout sélectionner ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          outlined: "",
                          rounded: "",
                          elevation: "0",
                          class: "ml-2 mt-1",
                          onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.clearAll())),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[142] || (_cache[142] = [
                            _createTextVNode(" Tout désélectionner ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referencedForms, (sheet, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            modelValue: _ctx.formsSelected,
                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.formsSelected) = $event)),
                            value: sheet.cerfaNumber,
                            color: "primary"
                          }, null, 8, ["modelValue", "value"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.selectedView === "bundle" ? _ctx.displayCerfaName(sheet) : _ctx.cleanSheetTitle(sheet)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "validDisabled"]))
          : _createCommentVNode("", true),
        (_ctx.bundleDeclarationDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 5,
              modelValue: _ctx.bundleDeclarationDialog,
              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.bundleDeclarationDialog) = $event)),
              title: "Validation avant envoi",
              "valid-loading": _ctx.sendBundleDialogLoading,
              "valid-title": "Télédéclarer",
              "valid-disabled": !_ctx.formsToSend.length || !_ctx.recipients.length,
              onValid: _cache[65] || (_cache[65] = ($event: any) => (_ctx.generateXML())),
              onClose: _cache[66] || (_cache[66] = ($event: any) => {
                _ctx.bundleDeclarationDialog = false;
                _ctx.formsToSend = [];
            })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _cache[143] || (_cache[143] = _createElementVNode("b", { class: "ml-3" }, "Choix des éléments à transmettre", -1)),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sendableElements, (element) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                cols: "4",
                                class: "d-flex justify-center align-center",
                                key: element.value
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_checkbox, {
                                    disabled: _ctx.elementIsDisabled(element),
                                    modelValue: _ctx.formsToSend,
                                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.formsToSend) = $event)),
                                    label: element.text,
                                    value: element.value,
                                    color: "primary"
                                  }, null, 8, ["disabled", "modelValue", "label", "value"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[144] || (_cache[144] = [
                        _createElementVNode("b", { class: "ml-3" }, "Choix des destinataires", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          disabled: !_ctx.hasCompanyOga,
                          modelValue: _ctx.recipients,
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.recipients) = $event)),
                          value: "DGFIP",
                          label: "DGFIP",
                          color: "primary"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          disabled: !_ctx.hasCompanyOga,
                          modelValue: _ctx.recipients,
                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.recipients) = $event)),
                          value: "OGA",
                          label: "OGA",
                          color: "primary"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        (_ctx.isBundleIncludedCVAE && _ctx.isCVAEeligible)
                          ? (_openBlock(), _createElementBlock("b", _hoisted_11, "Les deux feuillets concernant la 1330CVAE vont automatiquement être déplacés dans une nouvelle déclaration courante."))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[145] || (_cache[145] = [
                        _createElementVNode("b", { class: "ml-3" }, "Après validation, vous serez redirigé(e) vers la page \"Mon dossier\" pour clôturer l'exercice si vous le souhaitez.", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "valid-loading", "valid-disabled"]))
          : _createCommentVNode("", true),
        (_ctx.generateBookletDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 6,
              modelValue: _ctx.generateBookletDialog,
              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.generateBookletDialog) = $event)),
              title: "Choix de la plaquette",
              "valid-title": "Télécharger",
              onValid: _cache[70] || (_cache[70] = ($event: any) => (_ctx.generateBooklet())),
              onClose: _cache[71] || (_cache[71] = ($event: any) => (_ctx.generateBookletDialog = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.exportWithProjectWatermark,
                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.exportWithProjectWatermark) = $event)),
                      ripple: false,
                      class: "mb-1",
                      title: _ctx.$t('shared.exportWithProjectWatermark'),
                      label: _ctx.$t('shared.exportWithProjectWatermark')
                    }, null, 8, ["modelValue", "title", "label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.exportType,
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.exportType) = $event)),
                          items: [
                            { title: 'PDF', value: 'PDF' },
                            { title: 'Docx', value: 'DOCX' },
                        ],
                          label: "Format d'export",
                          outlined: "",
                          class: "mx-2 mt-2",
                          "hide-details": "",
                          density: "compact"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.generateConfirmationDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 7,
              modelValue: _ctx.generateConfirmationDialog,
              "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.generateConfirmationDialog) = $event)),
              title: "Confirmation changement de modèle",
              "valid-title": "Oui",
              onValid: _cache[73] || (_cache[73] = ($event: any) => (_ctx.onConfirmationChangeTemplate())),
              onClose: _cache[74] || (_cache[74] = ($event: any) => (_ctx.onCloseConfirmationDialog()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => _cache[146] || (_cache[146] = [
                        _createElementVNode("div", { class: "pt-2 px-4 pb-4" }, " Les modifications apportées à la plaquette en cours seront définitivement perdues, souhaitez-vous toujours changer de modèle ? ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.instructionsDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 8,
              modelValue: _ctx.instructionsDialog,
              "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.instructionsDialog) = $event)),
              height: "85%",
              onClose: _cache[76] || (_cache[76] = ($event: any) => (_ctx.instructionsDialog = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"width":"750px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => _cache[147] || (_cache[147] = [
                        _createElementVNode("iframe", {
                          src: "https://docs.google.com/document/d/1dqMm4_AdH_32YrDuTtp7aBoArlcpiPwWweXl1GX5ufQ/edit?pli=1",
                          width: "100%",
                          height: "750px"
                        }, null, -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}